import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { ClaimsTimeseries } from '@rivethealth/data/account';
import moment from 'moment';
import { of } from 'rxjs';
import { ClaimsMonitoringService } from '../../api/claims-monitoring.service';
import { HookDirective } from '../core/hook';
import { useLoad } from '../core/hooks';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'claims-monitoring-time-series',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'rv-rows large' },
  templateUrl: './time-series.component.html',
})
export class ClaimsMonitoringTimeSeriesComponent extends HookDirective {
  constructor(
    private readonly claimsService: ClaimsMonitoringService,
    _cdr: ChangeDetectorRef,
  ) {
    super(_cdr);
  }

  @Input() accountId: number;
  @Input() useServiceDate: boolean = true;
  showingDetail: boolean = false;

  get _() {
    const [accountCountsLoadable, reloadAccountCountsLoadable] = useLoad(() => {
      if (this.accountId) {
        return this.claimsService.getCountByAccountId(
          this.accountId,
          this.useServiceDate,
        );
      }
      return of(null);
    }, [this.accountId, this.useServiceDate]);

    const timeSeries =
      accountCountsLoadable.data?.series?.map(series => ({
        ...series,
        points: series.points.map(point => ({
          ...point,
          date: moment(point.date),
        })),
      })) || [];
    const startDate = moment(accountCountsLoadable?.data?.start);
    const endDate = moment(accountCountsLoadable?.data?.end);

    const startPlaceholder = moment();
    const endPlaceholder = moment().subtract(1, 'year');

    const timeSeriesCalculateValue = (points: { count: number }[]): number =>
      points.reduce((total, point) => total + point.count, 0);
    const timeSeriesValueFormatter = (value: number): string => String(value);

    return {
      accountCountsLoadable,
      startDate,
      endDate,
      startPlaceholder,
      endPlaceholder,
      timeSeries,
      timeSeriesCalculateValue,
      timeSeriesValueFormatter,
      showingDetail: this.showingDetail,
    };
  }

  shapeWeeklyData = (weekByWeekLoadable: Loadable<ClaimsTimeseries | null>) => {
    const returnObj: {
      date: string;
      count835: number;
      count837: number;
    }[] = [];

    weekByWeekLoadable.data?.series[0].points.forEach(point => {
      returnObj.push({
        date: moment(point.date).format('MMM DD YYYY'),
        count835: point.value.count ?? 0,
        count837:
          weekByWeekLoadable.data?.series[1].points.find(
            curPoint => curPoint.date == point.date,
          )?.value.count ?? 0,
      });
    });

    return returnObj.sort((a, b) => moment(b.date).diff(moment(a.date)));
  };
}
